import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getTasks } from "../services/task";

export const useTasks = (project: string) => {
  return useQuery({
    queryKey: ["get-tasks", project],
    queryFn: () => getTasks(project),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
};
